module.exports = require('../../es/string/starts-with');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/features/string/starts-with.js
// module id = 557
// module chunks = 0